export const dateTimeFormat = "DD-MMM-YYYY hh:mm A";
export const dateFormat = "DD-MMM-YYYY";
